export const TRANSIFY_PROJECT = 'SHOPEE_USER_TOB';
// Do not see any linked TRANSIFY_MAPPING asset
export const TRANSIFY_MAPPING = self.__ASSETS__
  ? self.__ASSETS__.TRANSIFY_MAPPING || {}
  : {};
export const TRANSIFY_COLLECTION_MAPPING = self.__ASSETS__
  ? self.__ASSETS__.UTM_COLLECTION_MAPPING ||
    self.__ASSETS__.TRANSIFY_COLLECTION_MAPPING ||
    {}
  : {};
